module.exports = __webpack_public_path__ + "img/icon-delete.36f12e42.svg";